import { Button, Box, Card, Typography } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { SEND_EMAIL_VERIFICATION } from "@auth/graphql/mutations/sendEmailVerification";
import { Mutation, MutationSendEmailVerificationArgs } from "@/app/graphql/codegen";
import { handleErrorWithNotification, showSuccessNotification } from "@/utils/errorHandling";
import { color } from "@/app/style/color";
import { semanticColors } from "@/app/style/semanticColors";

interface EmailVerificationBannerProps {
    userEmail: string;
    sx?: object;
}

export const EmailVerificationBanner = ({ userEmail, sx }: EmailVerificationBannerProps) => {
    const dispatch = useDispatch();
    const [isResending, setIsResending] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [sendEmailVerification] = useMutation<Pick<Mutation, "sendEmailVerification">, MutationSendEmailVerificationArgs>(SEND_EMAIL_VERIFICATION);

    const handleResendVerification = async () => {
        setIsResending(true);
        try {
            await sendEmailVerification({
                variables: { email: userEmail },
            });

            showSuccessNotification("Verifizierungs-E-Mail wurde erneut gesendet. Bitte prüfen Sie Ihr Postfach.", dispatch, "E-Mail gesendet");
            setEmailSent(true);
        } catch (error) {
            handleErrorWithNotification(error as Error, dispatch, "Fehler beim Senden", "Die Verifizierungs-E-Mail konnte nicht gesendet werden");
        } finally {
            setIsResending(false);
        }
    };

    return (
        <Card sx={{ border: `1px solid ${color.green.dark}`, p: 1, mb: 0, width: "100%", ...sx }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="body2" sx={{ mr: 2, flex: 1, minWidth: 0 }}>
                    Deine E-Mail-Adresse <strong>{userEmail}</strong> ist noch nicht verifiziert. Bitte prüfe Dein Postfach und klicke auf den Bestätigungslink.
                </Typography>

                <Box sx={{ flex: "0 0 33%", display: "flex", justifyContent: "center" }}>
                    {emailSent ? (
                        <Typography variant="body2" sx={{ color: color.green.dark, fontWeight: 500 }}>
                            E-Mail erfolgreich gesendet!
                        </Typography>
                    ) : (
                        <Button
                            color="inherit"
                            size="small"
                            variant="outlined"
                            onClick={handleResendVerification}
                            disabled={isResending}
                            fullWidth
                        >
                            {isResending ? "Wird gesendet..." : "E-Mail erneut senden"}
                        </Button>
                    )}
                </Box>
            </Box>
        </Card>
    );

    // return (
    //     <Alert
    //         severity="info"
    //         sx={sx}
    //         action={
    //             <Button color="inherit" size="small" variant="outlined" onClick={handleResendVerification} disabled={isResending}>
    //                 {isResending ? "Wird gesendet..." : "E-Mail erneut senden"}
    //             </Button>
    //         }
    //     >
    //         <AlertTitle sx={{ fontSize: "1rem", fontWeight: 500 }}>E-Mail-Adresse nicht verifiziert</AlertTitle>
    //         <Box sx={{ mt: 0.5, fontSize: "0.875rem" }}>
    //             Ihre E-Mail-Adresse <strong>{userEmail}</strong> ist noch nicht verifiziert. Bitte prüfen Sie Ihr Postfach und klicken Sie auf den Bestätigungslink.
    //         </Box>
    //     </Alert>
    // );
};
